module.exports = __webpack_public_path__ + "img/23.2c6df0de.png";